// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1PgcS","header":"PatientQuestionnaire_header__2qc2A","info":"PatientQuestionnaire_info__3rcFT"};